import { Video23Player } from '@pm2/media-component';
import { PlayIcon } from '@ui/kit/icons';
import { radioButtonMediaInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateTaskEntryMutation } from '../../../../state/mutations/update-task-entry.js';
import { useInputState } from '../../hook.use-input-state.js';
import { MediaBox } from '../atom.media-box/_media-box.js';
import { aspectRatio, box, printWrapper, printThumbnail, printPlayIcon } from './input.video.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function VideoInput(props) {
  const pageContext = usePageContext();
  const update = useUpdateTaskEntryMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => radioButtonMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, prev => {
      const next = Object.fromEntries(Object.entries(prev ?? {}).filter(([, value]) => value.type !== "radio-button-media" || value.taskId !== props.taskId));
      return {
        ...next,
        [props.node.id]: {
          type: "radio-button-media",
          taskId: props.taskId,
          markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
        }
      };
    });
  };
  const baseState = useInputState(props.node, inputEntry, {
    forceValidation: (node, entry) => !!entry?.markedAsCorrectAnswer
  });
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  const aspectAsScalar = props.node.twentyThreeVideo.height && props.node.twentyThreeVideo.width ? props.node.twentyThreeVideo.width / props.node.twentyThreeVideo.height : undefined;
  return /*#__PURE__*/jsx("div", {
    style: aspectRatio.__override(aspectAsScalar),
    children: /*#__PURE__*/jsx(MediaBox, {
      className: box,
      state: state,
      checked: !!inputEntry?.markedAsCorrectAnswer,
      onChange: onChange,
      orientation: props.orientation,
      theme: "rounded",
      children: pageContext === "print" ? /*#__PURE__*/jsxs("div", {
        className: printWrapper,
        children: [/*#__PURE__*/jsx("img", {
          className: printThumbnail,
          src: props.node.twentyThreeVideo.thumbnail,
          alt: ""
        }), /*#__PURE__*/jsx("div", {
          className: printPlayIcon,
          children: /*#__PURE__*/jsx(PlayIcon, {})
        })]
      }) : /*#__PURE__*/jsx(Video23Player, {
        photoId: props.node.twentyThreeVideo.id,
        token: props.node.twentyThreeVideo.token,
        aspectRatio: props.node.twentyThreeVideo.aspectRatio ?? undefined,
        title: undefined,
        caption: undefined,
        showSubtitlesByDefault: false
      })
    })
  });
}

export { VideoInput };
//# sourceMappingURL=input.video.js.map
